export default {
  // Unchanging information about the kind of campaign and action we're dealing with
  pageKind: null,
  baseUrl: null,
  repeatedAction: false,

  // Persistent success message
  thanksMessageKey: null,
  successMessageKey: null,

  // Information about our place in the chain
  currentStepKind: null,
  previousStepKind: null,
  hasNextStep: null,
  stepsProgress: null,

  // Information specific to the current step
  stepData: null,
  stepTrackingData: null
}
